<template>
  <div class="row">
    <div class="col-xs-12 col-md-6">
      <text-box :label="$t('synergrid.config.group')" data-cy="config-form-synergid-group" required v-model="value.group"></text-box>
    </div>
    <div class="col-xs-12 col-md-6">
      <number-box :label="$t('synergrid.config.power')" data-cy="config-form-synergid-power" required v-model="value.power"></number-box>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Inject } from 'vue-property-decorator'
import { idGenerator } from '@/services'
import { EnhanceRequestInfo } from '@/models'

@Component({
  name: 'synergrid-enhance-request-form',
})
export default class SynergridEnhanceRequestForm extends Vue {

  //#region [Property]
  @Prop({ type: Object, required: true })
  public readonly value!: EnhanceRequestInfo
  //#endregion

  //#region [Data]
  public fieldId: string = idGenerator.getId()
  //#endregion
}
</script>